<div class="flex flex-col w-full">
    <div class="bg-background w-full">
        <div class="container mx-auto text-center max-w-xl pt-6 pb-12 px-2">
            <app-explainer-text heading="Dein Trainingsbereich" id="training-overview">
                <p>
                    In den verschiedenen Modi kannst du Punkte sammeln und deine Fortschritte verfolgen.
                    Nach Abschluss der Prüfungssimulation erhältst du einen Überblick, wie gut du auf die Zertifizierung
                    vorbereitet bist.
                    <br />
                    Good luck & have fun!
                </p>
            </app-explainer-text>
        </div>
    </div>

    <div class="bg-background-dark w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
        <h2 class="pb-2">Deine Übersicht</h2>
        <div class="flex flex-nowrap gap-12 h-64 py-4">
            <!-- <div class="absolute right-0 w-20 h-56 from-white-dark bg-gradient-to-l z-50"></div> -->
            <a class="rounded cursor-pointer" (click)="selectCourse('all')">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h2 class="dark:text-white mt-8">Alle Kurse</h2>
        </div>
        <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4"
            [ngClass]="selectedCourseId === 'all' ? 'border-red' : 'opacity-50 border-white'">

            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded bg-center"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>

@for (course of availableCourses; track course.id) {
@if(course.access){
<a class="cursor-pointer" (click)="selectCourse(course.id)">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h2 class="dark:text-white mt-8">{{ course.name }}</h2>
        </div>
        <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4"
            [ngClass]="selectedCourseId === course.id ? 'border-red' : 'opacity-50 border-white'">

            <div class="absolute inset-0 bg-primary-hover opacity-[15%] dark:bg-primary rounded bg-center"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>
}
@else {
<a class="cursor-pointer" [routerLink]="'/kurse/' + course.id">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">

        <div class="grayscale absolute inset-0 rounded overflow-hidden flex flex-col justify-between">
            <div
                class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                <h2 class="dark:text-white mt-8">{{ course.name }}</h2>
            </div>
            <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 bg-grey border-4"
                [ngClass]="selectedCourseId === course.id ? 'border-red' : 'opacity-50 border-white'">
                <div class="absolute inset-0 opacity-[15%] rounded"></div>
            </div>
        </div>

        <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 flex flex-col justify-end items-center pointer-events-none"
            [ngClass]="selectedCourseId === course.id ? '' : 'opacity-50'">
            @if (course.price) {
            <img src="./assets/img/card-images/knoot_kaufbar.svg" class="w-14 mb-2" alt="Course Image">
            } @else {
            <ng-icon name="faSolidLock" class="w-12 mb-8 text-4xl text-blue dark:text-white"></ng-icon>
            }
        </div>
    </div>
</a>
}
}
        </div>
        <!-- <span>Mit 🚧 markierte Kurse sind noch im Aufbau</span> -->
    </div>

    @if(isLoading){
    <div class="container mx-auto text-center pt-40 min-h-screen">
        <ng-icon size="3rem" class="animate-spin" name="faSolidSpinner"></ng-icon>
    </div>
    } @else {
    <div>
        @if(achievements.length > 0){
<div class="bg-background w-full md:py-6 md:px-16 py-4 px-2">
    <h1>Deine bisherigen Erfolge</h1>
    <div class="flex flex-row flex-nowrap overflow-x-auto scrollbar overflow-y-hidden py-4 gap-12">
        <!-- <div class="absolute right-0 w-20 h-44 from-white-dark bg-gradient-to-l z-50"></div> -->
        @for(achievement of achievements; track achievement.id){
        <div
            class="dark-shadow font-shadow rounded shrink-0 w-44 h-44 flex flex-col justify-end text-center relative">

<i class="fa-solid fa-award z-50 text-3xl text-blue dark:text-white mb-5 block mx-auto"></i>
            <h3 class="z-50 text-lg pb-6 dark:text-white">
                @if(achievement.type === 'test-completions' && achievement.count === 1){
                Prüfung {{ achievement.expand.exam?.name }} bestanden!
                } @else if (achievement.type === 'test-completions') {
                Prüfung {{ achievement.expand.exam?.name }} {{ achievement.count }}x bestanden!
                } @else if (achievement.type === 'correct-streak') {
                {{ achievement.count }} Fragen in der Reihe richtig!
                }
            </h3>
            <div class="absolute w-44 h-44 flex text-center opacity-50 items-center rounded bg-primary opacity-[15%]"></div>
        </div>
        }
    </div>
</div>
}

        @if(selectedCourseId == 'all'){
        <div
            class="even:bg-background-dark odd:bg-background w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
            <h2 class="pb-2">Alle Kurse</h2>
            <div class="flex flex-nowrap gap-12 h-64 py-4">
                <!-- <div class="absolute right-0 w-20 h-56 from-white-dark bg-gradient-to-l z-50"></div> -->
                <a [routerLink]="['/repeat/start']">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="dark:text-white mt-8">Falsche Fragen
                wiederholen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_falschefragen.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>
            </div>
        </div>
        }

        @for(course of availableCourses; track course.id) {
        @if((selectedCourseId === 'all' || selectedCourseId === course.id) && course.access) {
        <div
            class="even:bg-background-dark odd:bg-background w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
            <h2 class="pb-2">{{ course.name }}</h2>
            <div class="flex flex-nowrap gap-12 h-64 py-4">
                <!-- <div class="absolute right-0 w-20 h-56 from-white-dark bg-gradient-to-l z-50"></div> -->
                <a [routerLink]="['/test/create', course.id]">
                    <div
                    class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
                    <div
                        class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                        <h3 class="text-base dark:text-white mt-8">Prüfungssimulation</h3>
                    </div>
                    <div
                        class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white"
                        >
                        <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

                        <div class="relative w-full h-full flex flex-col justify-end items-center">
                            <img src="./assets/img/card-images/knoot_pruefungssim.svg" class="w-14 mb-2" alt="Course Image">
                        </div>
                    </div>
                </div>
                </a>
                <a [routerLink]="['/endless/start', course.id]">
                    <div
                    class="group b-4 w-44 h-56 flex flex-col justify-between hover:w-48 hover:h-60 font-shadow shrink-0 transition-all relative dark-shadow rounded">
                    <div
                        class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                        <h3 class="text-base dark:text-white mt-8">Endlosmodus</h3>
                    </div>
                    <div
                        class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white"
                        >
                        <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

                        <div class="relative w-full h-full flex flex-col justify-end items-center">
                            <img src="./assets/img/card-images/knoot_endlosmodus.svg" class="w-14 mb-2" alt="Course Image">
                        </div>
                    </div>
                </div>
                </a>
                @if(course.hasBookAccess && course.bookDownloadUrl) {
                <a [href]="course.bookDownloadUrl" target="_blank" rel="noopener noreferrer">
                    <div
                        class="group b-4 w-44 h-56 flex flex-col justify-center hover:w-48 hover:h-60 font-shadow shrink-0 transition-all relative dark-shadow rounded">
                        <div
                            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                            <ng-icon class="z-40 text-4xl text-blue dark:text-white" name="faSolidBookOpen"></ng-icon>
                            <h3 class="text-base dark:text-white">Buch</h3>
                        </div>
                        <div
                            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 opacity-50 group-hover:opacity-75 flex flex-col justify-center shrink-0 shadow rounded bg-cover bg-center"
                            >
                        </div>
                    </div>
                </a>
                }
            </div>
        </div>
        }
        }
        @if(selectedCourseId != 'all'){
        <div
            class="even:bg-background-dark odd:bg-background w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
            <h2>Alle Kurse</h2>
            <div class="flex flex-nowrap gap-12 h-64 py-4">
                <!-- <div class="absolute right-0 w-20 h-56 from-white-dark bg-gradient-to-l z-50"></div> -->
                <a [routerLink]="['/repeat/start']">
                    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="dark:text-white mt-8">Falsche Fragen
                wiederholen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_falschefragen.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
                </a>
            </div>
        </div>
        }
    </div>
    }
</div>
